import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorsService } from '@perval/shared';
import { customEmailValidator } from '../../validators/perval-email.validator';
import { pervalLoginValidator } from '../../validators/perval-login.validator';
import { pervalOrganizationCodeValidator } from '../../validators/perval-organization-code.validator';
import { Credit } from '../models/credit';
import { CreditService } from '../services/credit.service';
import { UtilisateurService } from '../services/utilisateur.service';
@Component({
  selector: 'admin-manage-users-container',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  templateUrl: './manage-users.container.html',
  styleUrls: ['./manage-users.container.scss'],
})
export class ManageUsersContainer implements OnInit {
  packs: Credit.Pack[] = [];
  errorMsg!: string | undefined;

  public form = new FormGroup({
    firstName: new FormControl('', [Validators.maxLength(50)]),
    lastName: new FormControl('', [Validators.maxLength(100)]),
    email: new FormControl('', [
      Validators.required,
      customEmailValidator(),
      Validators.maxLength(255),
    ]),

    login: new FormControl('', [
      Validators.required,
      pervalLoginValidator(),
      Validators.maxLength(100),
    ]),
    code: new FormControl('', [
      Validators.required,
      Validators.maxLength(6),
      pervalOrganizationCodeValidator,
    ]),
    compagnyName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    adressLine1: new FormControl('', [Validators.maxLength(100)]),
    adressLine2: new FormControl('', [Validators.maxLength(100)]),
    adressLine3: new FormControl('', [Validators.maxLength(100)]),
    city: new FormControl('', [Validators.maxLength(50)]),
    zipCode: new FormControl('', [Validators.pattern('^\\d{5}$')]),
    emailOrganisme: new FormControl('', [
      customEmailValidator(),
      Validators.maxLength(255),
    ]),
    phone: new FormControl('', [
      Validators.pattern('^[0]{1}[123456789]{1}[0-9]{8}$'),
    ]),
    offerId: new FormControl('', [Validators.required]),
    isReplenishment: new FormControl({
      value: false,
      disabled: false,
    }),
  });

  constructor(
    private readonly utilisateurService: UtilisateurService,
    private readonly creditService: CreditService,
    private readonly errorsService: ErrorsService,
    private readonly snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    this.packs = await this.creditService.getAllPacks();
  }

  public packSelectionChanged(): void {
    const selectedPack = this.packs.find(
      (pack) => pack.id === this.form.value.offerId,
    );

    if (selectedPack?.specialLabel) {
      this.form.controls.isReplenishment.disable();
      this.form.controls.isReplenishment.setValue(false);
      this.form.value.isReplenishment = false;
    } else {
      this.form.controls.isReplenishment.enable();
    }
  }

  public async onSubmit(): Promise<void> {
    this.initMessages();

    try {
      if (this.form.valid) {
        await this.utilisateurService.createXNotUser({
          organization: {
            code: this.form.value.code as string,
            name: this.form.value.compagnyName as string,
            adressLine1: this.form.value.adressLine1 as string,
            adressLine2: this.form.value.adressLine2 as string,
            adressLine3: this.form.value.adressLine3 as string,
            city: this.form.value.city as string,
            postalCode: this.form.value.zipCode as string,
            email: this.form.value.emailOrganisme as string,
            phone: this.form.value.phone as string,
          },
          user: {
            email: this.form.value.email as string,
            firstName: this.form.value.firstName as string,
            lastName: this.form.value.lastName as string,
            login: this.form.value.login as string,
          },
          order: {
            offerId:
              this.form.value.offerId !== 'aucun'
                ? (this.form.value.offerId as string)
                : null,
            isReplenishment: this.form.value.isReplenishment as boolean,
          },
        });

        this.snackBar.open(
          'Utilisateur et organisme créés avec succès',
          'Fermer',
          {
            duration: 10000,
          },
        );
        this.form.reset();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      this.errorMsg = this.errorsService.getError(err.error.errors[0].message);
    }
  }

  private initMessages(): void {
    this.errorMsg = undefined;
  }
}
